module.exports = __webpack_public_path__ + "img/bg-page-1.931205e0.png";